import { ICroppedImages } from '../api/slice/types';
import { TypedRootState } from '../types';

export const selectCroppedImages = (state: TypedRootState): ICroppedImages => state.croppedImages;
